
import {mapGetters} from 'vuex';
import {rzIconDropArrow} from 'razlet-ui';

export default {
  name: 'sulu-side-links',
  components: { 
    rzIconDropArrow 
  },
  computed: {
    ...mapGetters('sulu', ['menu']),
    newMenuTree() {
      return [
        {
          name: '',
          link: '/',
          items: this.menu && this.menu.length ? this.menu : [],
        }
      ];
    },
    links () {
      const currentPath = this.$route.path;
      const parent = this.findParent(this.newMenuTree, currentPath);
      if (!parent) return [];
      return parent.items || [];
    },
  },
  methods: {
    findParent(children, path, parent = null) {
      for (let child of children) {
        let res = child.link === path ? parent : child.items && this.findParent(child.items, path, child);
        if (res) return res;
      }
    },
  },
};
